import React, { useEffect, useRef, useState, useCallback, useMemo } from "react";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import SubmitLoader from "../../../../components/common/loader/SubmitLoader";
import { useSnackbar } from "notistack";
import { useDispatch, useSelector } from "react-redux";
import { fetchHardwareDescriptions, replaceAllHardwareDescriptions } from "../../../../store/slices/hardwareDescriptionSlice";
import AdminLoader from "../../../../components/common/loader/AdminLoader";
import { getAllAutoSaveWorkentries, replaceAllWorkEntries } from "../../../../store/slices/autosaveSlice";
import { submitWorkEntries } from "../../../../store/slices/submitTaskSlice";
import { replaceAllDescriptionTasks } from "../../../../store/slices/descriptionTaskSlice";
import { useCurrencySymbol } from "../../../../utils/currencyUtils";
import CommaConvert from "../../../../utils/CommaConvert";
import {
  formatAmountComma,
  formatAmountForInput,
  validateAmountValue,
  parseAmountNumber,
} from "../../../../utils/decimalAmountUtils";
import { updateTaskStatus } from "../../../../store/slices/projectTaskStatusSlice";
import { getAllAssemblyInventory } from "../../../../store/slices/assemblyInventorySlice";
import {
  consolidateTrainingExpenseRowsForDisplay,
  resolveInstallationOtherExpenseRowsForPersistence,
  filterInstallationOngoingOtherExpenseDisplayRows,
  getLiveTrainingRollupForOpsAssigneeProject,
  isTrainingExpenseDisplayRow,
  mergeInstallationOtherExpenseRowsWithDefaults,
  normalizeAssignmentTypeServiceKey,
  normalizeTaskIdForScope,
  taskMatchesOpsManagerResourceOtherExpenses,
  taskProjectIdMatchesOpsManagerResourceScopes,
} from "../../../../utils/trainingOtherExpenseSync";

const TaskInputTable = ({
  handlerehardfresh,
  handlerefreshagain,
  hardwareData,
  employees,
  entries,
  tasks,
  items,
  row,
  rows,
  setRows,
  Action,
  setAction,
  hardwareAction,
  setHardwareAction,
  handlerefresh,
  taskTableRowId
}) => {
  const sanitizeDecimalInput = (inputValue) => {
    const cleaned = String(inputValue ?? "").replace(/[^0-9.]/g, "");
    const [integerPart, ...decimalParts] = cleaned.split(".");
    if (decimalParts.length === 0) return integerPart;
    return `${integerPart}.${decimalParts.join("")}`;
  };
  const roundHours = (value) => Number((Math.round((value + Number.EPSILON) * 100) / 100).toFixed(2));
  const getTypeServiceTabScopeKey = (typeService) => {
    const list = Array.isArray(typeService)
      ? typeService
      : typeService
        ? [typeService]
        : [];
    return list.map((s) => String(s || "").toLowerCase()).sort().join("|");
  };
  const maintaskdivRef = useRef(null);
  const skipServerSyncRef = useRef(false);
  const skipInstallationServerSyncRef = useRef(false);
  const dispatch = useDispatch();
  const currency = useCurrencySymbol();
  const USAComma = CommaConvert();
  const { mytrainings } = useSelector((state) => state.myTrainings);
  const { projects } = useSelector((state) => state.projects);

  const [, setRowAdded] = useState(false);
  const [projectname, setProjectname] = useState("");
  const [projectId, setProjectID] = useState("");
  const [, setTypeservice] = useState("");
  const [isLoading, SetisLoading] = useState(false);
  const [debounceTimer, setDebounceTimer] = useState(null);
  const [typingTimeout, setTypingTimeout] = React.useState(null);
  const [Assignperson, setAssignperson] = useState("");
  const [triprows, setTripRows] = useState([
    { description: "", value: "", notes: "" },
  ]);
  const projectScopeKey = `${row?._id ?? ""}|${projectname ?? ""}|${projectId ?? ""}`;
  const prevProjectScopeRef = useRef(projectScopeKey);
  const [tripRowsUserEditing, setTripRowsUserEditing] = useState(false);
  const [effortRowsUserEditing, setEffortRowsUserEditing] = useState(false);
  const [installationUserEditing, setInstallationUserEditing] = useState(false);

  useEffect(() => {
    if (prevProjectScopeRef.current !== projectScopeKey) {
      prevProjectScopeRef.current = projectScopeKey;
      setTripRowsUserEditing(false);
      setEffortRowsUserEditing(false);
      setInstallationUserEditing(false);
    }
  }, [projectScopeKey]);

  const appendManualOtherExpenseRow = (prev) => {
    const manuals = (prev || []).filter((r) => !isTrainingExpenseDisplayRow(r));
    const trains = (prev || []).filter((r) => isTrainingExpenseDisplayRow(r));
    if (manuals.length >= 15) return prev;
    return [...manuals, { description: "", value: "", notes: "" }, ...trains];
  };

  const [installation, setInstallation] = useState([
    { description: `Airfare (${currency}) `, value: "", notes: "" },
    { description: `Car Rental (${currency})`, value: "", notes: "" },
    { description: `Car fuel (${currency})`, value: "", notes: "" },
    { description: `Lodging (${currency})`, value: "", notes: "" },
    {
      description: `Miscellaneous Install Items to buy (${currency})`,
      value: "",
      notes: "",
    },
  ]);

  const moveMiscellaneousInstallRowToEnd = useCallback((rows = []) => {
    const miscIndex = rows.findIndex((r) =>
      String(r?.description || "").toLowerCase().includes("miscellaneous install items")
    );
    if (miscIndex === -1) return rows;
    const miscRow = rows[miscIndex];
    return [...rows.slice(0, miscIndex), ...rows.slice(miscIndex + 1), miscRow];
  }, []);

  const [tripduration, setTripDuration] = useState("");
  const tripdurationRef = useRef("");
  const [hardware, setHardware] = useState([{
    assemblepartdescription: "",
    partno: "",
    quantity: "",
    unitprice: "",
    totalprice: "",
  },]);
  const [fetchedHardwareData, setfetchedHardwareData] = useState([]);
  useEffect(() => {
    setProjectID(row._id)
    setProjectname(row.ProjectName);
    setTypeservice(row.TypeService);
  }, [row]);

  useEffect(() => {
    const total = rows.reduce((sum, entry) => {
      return sum + (parseFloat(entry.hoursassigned) || 0);
    }, 0);
    setTotalHoursAssigned(roundHours(total));
  }, [rows]);

  const [filteredEntries, setFilteredEntries] = useState([]);
  const { autosaveentries } = useSelector((state) => state.autosave);
  const [totalDollerValue, settotalDollerValue] = useState(0);

  const loggedInEmployee = React.useMemo(() => {
    const loggedEmail = String(localStorage.getItem("email") || "").trim().toLowerCase();
    return (employees || []).find(
      (e) => String(e?.EmpEmail || "").trim().toLowerCase() === loggedEmail
    );
  }, [employees]);

  const lockedTrainingRow = React.useMemo(() => {
    if (!loggedInEmployee?._id || !row) return null;
    const live = getLiveTrainingRollupForOpsAssigneeProject({
      projectRow: row,
      assigneeEmp: loggedInEmployee,
      trainingsEnvelope: mytrainings,
      projects: projects?.projects || projects || [],
      currencySymbol: currency,
      managerOPProject: row?.lead || row?.Lead || null,
    });
    if (!live) return null;
    const amount = Number(live.amount) || 0;
    if (amount <= 0 && !String(live.notes || "").trim()) return null;
    return {
      id: "training_cost",
      description: live.description || `Training Cost (${currency})`,
      amount,
      notes: live.notes || "",
    };
  }, [loggedInEmployee, mytrainings, row, currency, projects]);

  const lockedTrainingCostTotal = lockedTrainingRow ? Number(lockedTrainingRow.amount) || 0 : 0;
  const shouldShowLockedTrainingRows = lockedTrainingCostTotal > 0 || String(lockedTrainingRow?.notes || "").trim() !== "";

  const rowIsInstallation = useMemo(
    () => normalizeAssignmentTypeServiceKey(row?.TypeService) === "installation",
    [row?.TypeService]
  );
  const installationForTableDisplay = useMemo(() => {
    // Installation-only: hide empty template lines after submit. Non-installation rows keep all OP lines (e.g. Airfare on Software).
    if (!rowIsInstallation || Assignperson?.taskStatus !== "submit") {
      return installation;
    }
    return filterInstallationOngoingOtherExpenseDisplayRows(installation, row);
  }, [installation, row, rowIsInstallation, Assignperson?.taskStatus]);

  const [totalHoursAssigned, setTotalHoursAssigned] = useState(0);
  const { inventory } = useSelector((state) => state.assemblyInventory);
  const SidebarGroup = useSelector((state) => state.sidebar.SidebarGroup);

  useEffect(() => {
    if (!effortRowsUserEditing && rows.length === 0) {
      setRows([{ task: "", hoursassigned: "", notes: "" }]);
    }
  }, [rows, effortRowsUserEditing, setRows]);

  useEffect(() => {
    if (!tripRowsUserEditing && triprows.length === 0) {
      setTripRows([{ description: "", value: "", notes: "" }]);
    }
  }, [triprows, tripRowsUserEditing]);

  const [initialEdit, setInitialEdit] = useState(false);

  useEffect(() => {
    skipServerSyncRef.current = false;
    setInitialEdit(false);
  }, [row?._id]);

  const markUserEditing = () => {
    skipServerSyncRef.current = true;
    setInitialEdit(true);
  };

  useEffect(() => {
    if (row && row.Assignedperson) {
      const userEmail = localStorage.getItem('email');
      const assignedPerson = row.Assignedperson.find(
        person => person.email === userEmail
      );
      setAssignperson(assignedPerson)
    }
  }, [row]);

  useEffect(() => {
    if (!row?._id) return;
    const userEmail = localStorage.getItem("email");
    const currentEmployee = employees.find((emp) => emp.EmpEmail === userEmail);
    if (!currentEmployee) return;
    const leadLike = row?.lead || row?.Lead || null;
    const matchedtaskEntries = autosaveentries.filter(
      (entry) =>
        taskProjectIdMatchesOpsManagerResourceScopes(
          { projectid: entry.projectid, taskownerid: entry.taskownerid },
          row,
          leadLike
        ) &&
        normalizeTaskIdForScope(entry?.taskownerid) ===
          normalizeTaskIdForScope(currentEmployee._id)
    );
    const matchedexpensesEntries = tasks.filter(
      (entry) =>
        normalizeTaskIdForScope(entry?.taskownerid) ===
          normalizeTaskIdForScope(currentEmployee._id) &&
        taskMatchesOpsManagerResourceOtherExpenses(entry, row, leadLike)
    );
    const matchedhardwareEntries = items.filter(
      (entry) =>
        taskProjectIdMatchesOpsManagerResourceScopes(
          { projectid: entry.projectid, taskownerid: entry.taskownerid },
          row,
          leadLike
        ) &&
        normalizeTaskIdForScope(entry?.taskownerid) ===
          normalizeTaskIdForScope(currentEmployee._id)
    );
    if (matchedtaskEntries.length) {
      setFilteredEntries(matchedtaskEntries);
    } else if (matchedexpensesEntries.length) {
      setFilteredEntries(matchedexpensesEntries);
    } else if (matchedhardwareEntries.length) {
      setFilteredEntries(matchedhardwareEntries);
    }
    if (!effortRowsUserEditing && !initialEdit) {
      if (matchedtaskEntries.length > 0) {
        setRows(matchedtaskEntries.map((entry) => ({ ...entry })));
      } else {
        setRows([{ task: "", hoursassigned: "", notes: "" }]);
      }
    }
  }, [entries, autosaveentries, employees, row, setRows, initialEdit, tasks, items, effortRowsUserEditing]);

  useEffect(() => {
    dispatch(getAllAutoSaveWorkentries());
    dispatch(getAllAssemblyInventory());

  }, [dispatch]);

  useEffect(() => {
    console.log("dasdas", inventory)
    // Filter by SidebarGroup (selected group from Settings like "Sensr")
    // If SidebarGroup is not set, fall back to row?.AssignedGroup
    const selectedGroup = SidebarGroup || row?.AssignedGroup;
    
    const matchedtaskEntries = inventory.filter(
      (entry) => entry.group === selectedGroup
    );
    
    const newhardwareRows = matchedtaskEntries?.map((hardware) => ({
      _id: hardware._id,
      assemblepartdescription: hardware.assembly || "",
      partnumber: hardware.partnumber || "",
      unitprice: hardware.unitprice || "",
    }));
    setfetchedHardwareData(newhardwareRows)
  }, [hardwareData, inventory, employees, row, SidebarGroup]);

  useEffect(() => {
    if (hardware.length === 0) {
      setHardware([{
        assemblepartdescription: "",
        partno: "",
        quantity: "",
        unitprice: "",
        totalprice: "",
      },])
    }
  }, [hardware, setHardware]);

  useEffect(() => {
    if (skipServerSyncRef.current || initialEdit) return;

    const loggedInUserEmail = localStorage.getItem("email"); // Assuming you store email as 'userEmail'

    if (tripRowsUserEditing) return;

    if (projectname && tasks.length > 0 && loggedInUserEmail) {
      // Find the employee with matching email
      const loggedInEmployee = employees.find(
        (emp) => emp.EmpEmail === loggedInUserEmail
      );

      if (loggedInEmployee) {
        const leadLike = row?.lead || row?.Lead || null;
        const employeeSpecificTasks = tasks.filter(
          (task) =>
            normalizeTaskIdForScope(task?.taskownerid) ===
              normalizeTaskIdForScope(loggedInEmployee._id) &&
            taskMatchesOpsManagerResourceOtherExpenses(task, row, leadLike)
        );

        const manualTasks = employeeSpecificTasks.filter(
          (task) => !isTrainingExpenseDisplayRow(task)
        );
        const newTripRows = consolidateTrainingExpenseRowsForDisplay(
          manualTasks.map((task) => ({
            description: task.description || "",
            value: task.value || "",
            notes: task.notes || "",
          }))
        );

        const total = newTripRows.reduce((sum, r) => sum + parseAmountNumber(r.value), 0);
        settotalDollerValue(total);
        setTripRows(
          newTripRows.length > 0
            ? newTripRows
            : [{ description: "", value: "", notes: "" }]
        );
      }
    }
  }, [projectname, tasks, projectId, employees, row, tripRowsUserEditing, initialEdit]);


  useEffect(() => {
    const userEmail = localStorage.getItem("email");
    const currentEmployee = employees.find((emp) => emp.EmpEmail === userEmail);
    if (currentEmployee) {
      if (items && items?.length > 0) {
        // Filter items where taskownerid matches currentEmployee._id
        const leadLike = row?.lead || row?.Lead || null;
        const filteredHardware = items.filter(
          (item) =>
            normalizeTaskIdForScope(item?.taskownerid) ===
              normalizeTaskIdForScope(currentEmployee?._id) &&
            taskProjectIdMatchesOpsManagerResourceScopes(
              { projectid: item.projectid, taskownerid: item.taskownerid },
              row,
              leadLike
            )
        );
        setHardware(
          filteredHardware?.length > 0
            ? filteredHardware
            : [{
              assemblepartdescription: "",
              partno: "",
              quantity: "",
              unitprice: "",
              totalprice: "",
              taskownerid: currentEmployee._id // Make sure to include this
            }]
        );
      }
    }
  }, [items, row, employees]);

  // Keep tripdurationRef in sync for use in callbacks (avoids stale closures)
  useEffect(() => {
    tripdurationRef.current = tripduration;
  }, [tripduration]);

  useEffect(() => {
    if (skipServerSyncRef.current || initialEdit) return;

    const typeService = row?.TypeService;
    const isInstallation = Array.isArray(typeService)
      ? typeService.some((s) => String(s || "").toLowerCase().includes("installation"))
      : String(typeService || "").toLowerCase().includes("installation");
    if (!isInstallation || !row?._id) return;
    if (installationUserEditing) return;
    if (skipInstallationServerSyncRef.current) return;
    const userEmail = localStorage.getItem("email");
    const currentEmployee = employees.find((emp) => emp.EmpEmail === userEmail);
    const employeeId = currentEmployee?._id;
    // Keep trip duration strictly employee-specific.
    // Do not fall back to project-level rows, otherwise one assignee's value
    // can appear for another assignee in Other Expenses > Trip Duration (Days).
    if (!employeeId) {
      setInstallation([
        { description: `Airfare (${currency})`, value: "", notes: "" },
        { description: `Car Rental (${currency})`, value: "", notes: "" },
        { description: `Car fuel (${currency})`, value: "", notes: "" },
        { description: `Lodging (${currency})`, value: "", notes: "" },
        {
          description: `Miscellaneous Install Items to buy (${currency})`,
          value: "",
          notes: "",
        },
      ]);
      setTripDuration("");
      return;
    }
    const leadLike = row?.lead || row?.Lead || null;
    const matchedTasks = tasks.filter(
      (task) =>
        taskProjectIdMatchesOpsManagerResourceScopes(task, row, leadLike) &&
        normalizeTaskIdForScope(task?.taskownerid) ===
          normalizeTaskIdForScope(employeeId)
    );

    if (matchedTasks.length) {
      const tasksForLoad =
        Assignperson?.taskStatus === "submit"
          ? filterInstallationOngoingOtherExpenseDisplayRows(matchedTasks, row)
          : matchedTasks;
      const merged = mergeInstallationOtherExpenseRowsWithDefaults(tasksForLoad, currency);
      setInstallation(moveMiscellaneousInstallRowToEnd(merged));
      const tripDur =
        merged.find((t) => t.tripduration != null && String(t.tripduration).trim() !== "")?.tripduration ??
        matchedTasks.find((t) => t.tripduration != null)?.tripduration;
      setTripDuration(tripDur != null ? String(tripDur) : "");
    } else {
      setInstallation([
        { description: `Airfare (${currency})`, value: "", notes: "" },
        { description: `Car Rental (${currency})`, value: "", notes: "" },
        { description: `Car fuel (${currency})`, value: "", notes: "" },
        { description: `Lodging (${currency})`, value: "", notes: "" },
        {
          description: `Miscellaneous Install Items to buy (${currency})`,
          value: "",
          notes: "",
        },
      ]);
      setTripDuration("");
    }
  }, [projectname, row, tasks, employees, currency, moveMiscellaneousInstallRowToEnd, installationUserEditing, initialEdit, Assignperson?.taskStatus]);

  const { enqueueSnackbar } = useSnackbar();

  const [isLoadingtask, setisLoadingtask] = useState(false);

  const handleAddRow = () => {
    setTripRowsUserEditing(true);
    setTripRows((prev) => {
      const manuals = (prev || []).filter((r) => !isTrainingExpenseDisplayRow(r));
      if (manuals.length >= 15) {
        enqueueSnackbar("You can only add up to 15 rows.", { variant: "error" });
        return prev;
      }
      return appendManualOtherExpenseRow(prev);
    });
  };

  const handleRemoveRow = () => {
    setTripRowsUserEditing(true);
    let removeIdx = -1;
    for (let i = triprows.length - 1; i >= 0; i -= 1) {
      if (!isTrainingExpenseDisplayRow(triprows[i])) {
        removeIdx = i;
        break;
      }
    }
    if (removeIdx < 0) return;
    const updatedRows = consolidateTrainingExpenseRowsForDisplay(
      triprows.filter((_, i) => i !== removeIdx)
    );
    setTripRows(updatedRows);
    const total = updatedRows.reduce((sum, r) => sum + parseAmountNumber(r.value), 0);
    settotalDollerValue(total);
    setTimeout(() => {
      handleDescriptionSubmitofManagerAuto(updatedRows);
    }, 2000);
  };

  // Handle adding a new row to task rows
  const handleAddTaskRow = () => {
    if (rows.length < 15) {
      setEffortRowsUserEditing(true);
      setInitialEdit(true);
      setRowAdded(true);
      setRows([...rows, { task: "", hoursassigned: "", notes: "" }]); // ✅ USE rows
    } else {
      enqueueSnackbar("You can only add up to 15 rows.", { variant: "error" });
    }
  };

  const handleRemoveTaskRow = (index) => {
    setEffortRowsUserEditing(true);
    // if (rows.length > 1) {
    markUserEditing();
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
    setRowAdded(true);
    const total = updatedRows.reduce((sum, entry) => {
      return sum + (parseFloat(entry.hoursassigned) || 0);
    }, 0);
    setTotalHoursAssigned(roundHours(total));
    // Use the updatedRows directly instead of relying on the state
    setTimeout(() => {
      handletaskSubmit(updatedRows); // Pass the updated rows directly
    }, 2000);
    // }
  };

  const [, setLoggedEmp] = useState(null);

  useEffect(() => {
    const loggedInUserEmail = localStorage.getItem("email");
    const loggedInEmployee = employees.find(
      (emp) => emp.EmpEmail === loggedInUserEmail
    );
    setLoggedEmp(loggedInEmployee);
  }, [employees]);

  // Only set default tab when project / service scope changes — not on autosave refresh
  // (row object reference updates would otherwise force "Effort Expenses" while typing).
  const typeServiceScopeKey = useMemo(
    () => getTypeServiceTabScopeKey(row?.TypeService),
    [row?.TypeService]
  );
  const defaultTabScopeKey = useMemo(
    () => `${row?._id ?? ""}|${typeServiceScopeKey}`,
    [row?._id, typeServiceScopeKey]
  );
  const prevDefaultTabScopeRef = useRef(null);
  useEffect(() => {
    if (prevDefaultTabScopeRef.current === defaultTabScopeKey) return;
    prevDefaultTabScopeRef.current = defaultTabScopeKey;

    const hasHardware = typeServiceScopeKey.includes("hardware");

    if (hasHardware) {
      setAction("");
      setHardwareAction("hardwarecost");
    } else {
      setAction("task");
      setHardwareAction("");
    }
  }, [defaultTabScopeKey, typeServiceScopeKey, setAction, setHardwareAction]);

  const handleInputChange = (index, field, value) => {
    setEffortRowsUserEditing(true);
    const newRows = [...rows];
    let validatedValue = value;
    if (field === 'hoursassigned') {
      validatedValue = sanitizeDecimalInput(value);
    } else if (field === 'task' || field === 'notes') {
      validatedValue = value.replace(/[^a-zA-Z0-9 .,?'-]/g, ""); // Allow alphanumeric and some special chars
    }

    newRows[index][field] = validatedValue;
    if (field === 'hoursassigned') {
      const total = newRows.reduce((sum, entry) => {
        return sum + (parseFloat(entry.hoursassigned) || 0);
      }, 0);
      setTotalHoursAssigned(roundHours(total));
    }
    setRows(newRows);
    markUserEditing();
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }
    const timer = setTimeout(() => {
      handletaskSubmit(newRows);
    }, 2000);
    setDebounceTimer(timer);
  };

  useEffect(() => {
    return () => {
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }
    };
  }, [debounceTimer]);

  useEffect(() => {
    return () => {
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }
    };
  }, [typingTimeout]);

  const handleTripInputChange = (index, field, value) => {
    if (isTrainingExpenseDisplayRow(triprows[index])) return;
    setTripRowsUserEditing(true);
    const nextValue =
      field === "value" ? validateAmountValue(value) : value;
    const newRows = [...triprows];
    newRows[index][field] = nextValue;
    setTripRows(newRows);
    markUserEditing();

    if (field === 'value') {
      const total = newRows.reduce((sum, row) => {
        return sum + parseAmountNumber(row.value);
      }, 0);
      settotalDollerValue(total);
    }
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    const newTimeout = setTimeout(() => {
      handleDescriptionSubmitofManagerAuto(newRows);
    }, 2000);

    setTypingTimeout(newTimeout);
  };

  const validateDescriptionOrNotes = (value) => {
    return value.replace(/[^a-zA-Z0-9 .,?'-]/g, "");
  };

  const handletaskSubmit = React.useCallback(async (rowsToSubmit) => {
    const filteredRows = rowsToSubmit.filter(entry => {
      return (entry.task && entry.task.trim() !== "") ||
        (entry.hoursassigned && entry.hoursassigned.toString().trim() !== "") ||
        (entry.notes && entry.notes.trim() !== "");
    });

    const invalidRows = filteredRows.filter(row => {
      const hasDescription = row.task && row.task.trim() !== "";
      const hasValue = row.hoursassigned !== undefined && row.hoursassigned !== null && row.hoursassigned.toString().trim() !== "";
      return !hasDescription || !hasValue;
    });

    if (invalidRows.length > 0) {
      return;
    }


    const projectid = row._id;
    const cleanedData = filteredRows.map((entry) => ({
      task: entry.task || "",
      hoursassigned: Number(entry.hoursassigned) || 0,
      notes: entry.notes || "",
    }));

    setisLoadingtask(true);
    try {
      await dispatch(replaceAllWorkEntries({
        projectid: projectid,
        newEntries: cleanedData || [],
        tasktype: "self"
      }));
    } catch (error) {
      console.error("Operation failed:", error);
    } finally {
      setEffortRowsUserEditing(false);
      dispatch(getAllAutoSaveWorkentries());
      if (cleanedData?.length > 0) {
        setFilteredEntries(cleanedData);
      }
      setisLoadingtask(false);
    }
  }, [row, dispatch]);

  const handledirectSubmit = async () => {
    const serviceType = row.TypeService.toLowerCase();

    if (serviceType.includes('installation') && !tripduration) {
      return
    }
    const email = localStorage.getItem("email");
    const currentEmployee = employees.find((emp) => emp.EmpEmail === email);
    const projectid = row._id
    const taskownerid = currentEmployee?._id
    setisLoadingtask(true);
    try {
      await dispatch(submitWorkEntries({ projectid, taskownerid }));
    } catch (error) {
      console.error("Operation failed:", error);
    } finally {
      dispatch(getAllAutoSaveWorkentries());
      setisLoadingtask(false);
    }
  };

  const updatebyname = useCallback(async () => {

    const serviceType = row.TypeService.toLowerCase();

    if (serviceType.includes('installation') && !tripduration) {
      return
    }

    const email = localStorage.getItem("email");
    const updatedAssignedperson = (row.Assignedperson || [])
      .filter(person => person.email === email)
      .map(person => ({
        ...person,
        taskStatus: "submit",
      }));
    const filteredEmployee = employees.find((emp) => emp?.EmpEmail === updatedAssignedperson[0]?.email);
    const selectedProjectId = row?._id;
    const loggedInUserId = filteredEmployee?._id;

    setisLoadingtask(true);
    try {
      await dispatch(updateTaskStatus({
        projectid: selectedProjectId,
        userid: loggedInUserId
      }))
    } catch (error) {
      console.error("Operation failed:", error);
    } finally {
      dispatch(getAllAutoSaveWorkentries());
      setisLoadingtask(false);
    }
  }, [dispatch, row, employees, tripduration]);

  const handleDescriptionSubmitofManagerAuto = React.useCallback(async (newRows) => {
    const filteredRows = newRows.filter((row) => {
      if (isTrainingExpenseDisplayRow(row)) return false;
      return (
        (row.description && row.description.trim() !== "") ||
        (row.value && row.value.toString().trim() !== "") ||
        (row.notes && row.notes.trim() !== "")
      );
    });
    const invalidRows = filteredRows.filter(row => {
      const hasDescription = row.description && row.description.trim() !== "";
      const hasValue = row.value !== undefined && row.value !== null && row.value.toString().trim() !== "";
      return !hasDescription || !hasValue;
    });

    if (invalidRows.length > 0) {
      return;
    }

    setisLoadingtask(true)
    try {
      const formdata = filteredRows.map((row) => ({
        ...row,
        taskstatus: "submit"
      }));
      await dispatch(replaceAllDescriptionTasks({
        projectid: projectId,
        tasktype: "self",
        entries: [...formdata]
      }));

    } catch (error) {
      console.error("Operation failed:", error);
    } finally {
      setisLoadingtask(false)
      setInitialEdit(false);
      setTripRowsUserEditing(false);
      dispatch(fetchHardwareDescriptions());
      handlerefreshagain()
    }
  }, [dispatch, projectId, handlerefreshagain]);


  const handleDescriptionSubmitofManager = React.useCallback(async () => {
    const manualTripRows = triprows.filter((r) => !isTrainingExpenseDisplayRow(r));
    const hasEmptyFields = manualTripRows.some((row) => {
      return (
        !row.description?.trim() ||
        !row.notes?.trim() ||
        row.value === "" ||
        row.value === null ||
        row.value === undefined
      );
    });
    if (hasEmptyFields) {
      return;
    }
    setisLoadingtask(true)
    try {
      const formdata = manualTripRows.map((row) => ({
        ...row,
        taskstatus: "submit"
      }));
      await dispatch(replaceAllDescriptionTasks({
        projectid: projectId,
        tasktype: "self",
        entries: [...formdata]
      }));
    } catch (error) {
      console.error("Operation failed:", error);
    } finally {
      setisLoadingtask(false)
      setInitialEdit(false);
      dispatch(fetchHardwareDescriptions());
    }
  }, [triprows, dispatch, projectId]);

  const handleInstallationChange = (index, field, value) => {
    setInstallationUserEditing(true);
    const nextValue =
      field === "value" ? validateAmountValue(value) : value;
    setInstallation((prev) => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        [field]: nextValue,
      };

      if (field === 'value') {
        const total = updated.reduce((sum, row) => {
          return sum + parseAmountNumber(row.value);
        }, 0);
        settotalDollerValue(total);
      }

      return updated;
    });

    setRowAdded(true);

    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    const newTimeout = setTimeout(() => {
      setInstallation((latestInstallation) => {
        handleinstallationtaskSubmitAuto(tripdurationRef.current, latestInstallation);
        return latestInstallation; 
      });
    }, 2000);
    setTypingTimeout(newTimeout);
  };

  const handletripdurationChange = (value) => {
    const numericValue = value.replace(/[^0-9]/g, "");
    setInstallationUserEditing(true);
    setTripDuration(numericValue);
    tripdurationRef.current = numericValue;
    setRowAdded(true);
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }
    const newTimeout = setTimeout(() => {
      handleinstallationtaskSubmitAuto(numericValue);
    }, 2000);
    setTypingTimeout(newTimeout);
  };

  const handleinstallationtaskSubmitAuto = React.useCallback(async (numericValue, installationData = null) => {
    const dataToSave = installationData || installation;
    const filteredRows = resolveInstallationOtherExpenseRowsForPersistence(
      dataToSave || [],
      row,
      { forSubmit: false }
    );
   
    const invalidRows =
      filteredRows.length > 0
        ? filteredRows.filter(
            (row) => !(row.description && row.description.trim() !== "")
          )
        : [];

    if (invalidRows.length > 0) {
      return;
    }
    const tripDurToSave = numericValue || tripdurationRef.current || filteredRows[0]?.tripduration;
    setisLoadingtask(true);
    try {
      const formdata = filteredRows.map((row) => ({
        ...row,
        taskstatus: "submit",
        tripduration: tripDurToSave
      }));

      await dispatch(replaceAllDescriptionTasks({
        projectid: row._id,
        tasktype: "self",
        entries: [...formdata]
      }));
    } catch (error) {
      console.error("Operation failed:", error);
    } finally {
      setRowAdded(false);
      setInitialEdit(false);
      setInstallationUserEditing(false);
      setisLoadingtask(false);
      dispatch(fetchHardwareDescriptions());
      handlerefreshagain();
    }
  }, [dispatch, row, handlerefreshagain, installation]);

  const handleinstallationtaskSubmit = React.useCallback(async (numericValue) => {
    if (!numericValue && !installation[0]?.tripduration) {
      enqueueSnackbar("Please add tripduration.", {
        variant: "error",
      })
      return
    }
    setisLoadingtask(true)
    let rowsToSave = [];
    try {
      rowsToSave = resolveInstallationOtherExpenseRowsForPersistence(
        installation || [],
        row,
        { forSubmit: true }
      );
      const formdata = rowsToSave.map((row) => ({
        ...row,
        taskstatus: "submit",
        tripduration: numericValue || installation[0]?.tripduration
      }));
      await dispatch(replaceAllDescriptionTasks({
        projectid: row._id,
        tasktype: "self",
        entries: [...formdata]
      }));
    } catch (error) {
      console.error("Operation failed:", error);

    } finally {
      if (rowIsInstallation && rowsToSave.length > 0) {
        const manualPersisted = rowsToSave.filter((r) => !isTrainingExpenseDisplayRow(r));
        const trainingPersisted = rowsToSave.filter((r) => isTrainingExpenseDisplayRow(r));
        const mergedPersisted = mergeInstallationOtherExpenseRowsWithDefaults(
          manualPersisted,
          currency
        );
        skipInstallationServerSyncRef.current = true;
        setInstallation(
          moveMiscellaneousInstallRowToEnd([...mergedPersisted, ...trainingPersisted])
        );
      }
      setRowAdded(false);
      setInitialEdit(false);
      setisLoadingtask(false);
      Promise.resolve(handlerefresh()).finally(() => {
        skipInstallationServerSyncRef.current = false;
      });
    }
  }, [
    dispatch,
    installation,
    setisLoadingtask,
    row,
    handlerefresh,
    enqueueSnackbar,
    rowIsInstallation,
    currency,
    moveMiscellaneousInstallRowToEnd,
  ]);

  const handleAddinstallationrow = () => {
    markUserEditing();
    setRowAdded(true);
    if (installation.length >= 15) return; // Maximum 15 rows
    setInstallationUserEditing(true);
    setInstallation([...installation, { description: "", value: "", notes: "" }]);
  };

  const handleRemoveinstallationrow = () => {
    markUserEditing();
    setInstallationUserEditing(true);
    const newRows = [...installation];
    newRows.pop();
    const total = newRows.reduce((sum, row) => {
      return sum + parseAmountNumber(row.value);
    }, 0);
    settotalDollerValue(total);
    setInstallation(newRows);
    setRowAdded(true);
    setTimeout(() => {
      handleinstallationtaskSubmitAuto(tripdurationRef.current, newRows);
    }, 2000);
  };

  const handleAddHardware = () => {
    if (hardware.length >= 15) return;

    setHardware([
      ...hardware,
      {
        assemblepartdescription: "",
        partno: "",
        quantity: "",
        unitprice: "",
        totalprice: "",
      },
    ]);
    resetTypingTimeout();
  };

  const handlehardwaretaskAuto = useCallback(async (hardware) => {
    const transformedData = hardware.map((item) => ({
      ...item,
      taskstatus: "autosubmit",
    }));
    const payload = {
      projectid: row._id,
      tasktype: "self",
      tasks: transformedData
    };
    setisLoadingtask(true)
    try {
      await dispatch(replaceAllHardwareDescriptions(payload));
    } catch (error) {
      console.error("Error submitting hardware:", error);
      throw error;
    } finally {
      setisLoadingtask(false)
      handlerehardfresh()
    }
  }, [row, dispatch, handlerehardfresh]);
  const resetTypingTimeout = useCallback(() => {
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }
    const newTimeout = setTimeout(() => {
      handlehardwaretaskAuto(hardware);
    }, 3000);
    setTypingTimeout(newTimeout);
  }, [typingTimeout, hardware, handlehardwaretaskAuto]);

  const handleRemoveHardware = () => {
    const newHardware = [...hardware];
    newHardware.pop();
    setHardware(newHardware);
    setTimeout(() => {
      handlehardwaretaskAuto(newHardware); // Pass the updated rows directly
    }, 2000);
    setRowAdded(true);
  };

  const handlehardwareInputChange = (index, key, value) => {
    const updated = [...hardware];
    if (key === "assemblepartdescription") {
      const selectedPart = fetchedHardwareData?.find(
        (item) => item.assemblepartdescription === value
      );
      if (selectedPart) {
        updated[index] = {
          ...updated[index],
          assemblepartdescription: selectedPart.assemblepartdescription,
          partno: selectedPart.partnumber,
          unitprice: selectedPart.unitprice.toString(),
          quantity: "", // Reset quantity to empty string
          totalprice: "", // Reset total price since quantity is now empty
        };
      } else {
        updated[index] = {
          ...updated[index],
          assemblepartdescription: value,
          partno: "",
          unitprice: "",
          quantity: "", // Reset quantity to empty string
          totalprice: "", // Reset total price
        };
      }
    } else if (key === "quantity") {
      const quantity = Number(value);
      const unitprice = Number(updated[index].unitprice || 0);

      updated[index] = {
        ...updated[index],
        quantity: value,
        totalprice:
          !isNaN(quantity) && quantity !== 0
            ? (unitprice * quantity).toFixed(2)
            : "0.00",
      };
    } else {
      updated[index][key] = value;
    }
    setHardware(updated);
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }
    const newTimeout = setTimeout(() => {
      handlehardwaretaskAuto(updated);
    }, 3000);
    setTypingTimeout(newTimeout);
  };


  const handlehardwaretaskSubmit = useCallback(async (hardware) => {
    const transformedData = hardware.map((item) => ({
      ...item,
      taskstatus: "submit",
    }));
    const payload = {
      projectid: row._id,
      tasktype: "self",
      tasks: transformedData
    };
    setisLoadingtask(true)
    try {
      await dispatch(replaceAllHardwareDescriptions(payload));
    } catch (error) {
      console.error("Error submitting hardware:", error);
      throw error;
    } finally {
      setisLoadingtask(false)
    }
  }, [row, dispatch]);

  const handleSelectOpen = () => {
    resetTypingTimeout();
  };

  const hasValidEffortEntry = React.useMemo(
    () =>
      (rows || []).some(
        (entry) =>
          entry.task &&
          String(entry.task).trim() !== "" &&
          entry.hoursassigned !== undefined &&
          entry.hoursassigned !== null &&
          String(entry.hoursassigned).trim() !== ""
      ),
    [rows]
  );

  const hasValidOtherExpenseEntry = React.useMemo(
    () =>
      (triprows || []).some(
        (r) =>
          !isTrainingExpenseDisplayRow(r) &&
          r.description &&
          String(r.description).trim() !== "" &&
          r.value !== undefined &&
          r.value !== null &&
          String(r.value).trim() !== ""
      ),
    [triprows]
  );

  const hasValidInstallationExpenseEntry = React.useMemo(
    () =>
      (installation || []).some(
        (r) =>
          r.description &&
          String(r.description).trim() !== "" &&
          r.value !== undefined &&
          r.value !== null &&
          String(r.value).trim() !== ""
      ),
    [installation]
  );

  const hasValidHardwareEntry = React.useMemo(
    () =>
      (hardware || []).some(
        (item) =>
          item.assemblepartdescription &&
          String(item.assemblepartdescription).trim() !== "" &&
          item.quantity &&
          Number(item.quantity) > 0
      ),
    [hardware]
  );

  const canShowSubmit =
    (filteredEntries?.length > 0) ||
    hasValidEffortEntry ||
    hasValidOtherExpenseEntry ||
    hasValidInstallationExpenseEntry ||
    hasValidHardwareEntry;

  // Check if all tasks with task name have hours filled
  const areAllTaskHoursFilled = () => {
    if (!rows || rows.length === 0) return true;
    
    // Filter rows that have a task name filled
    const rowsWithTask = rows.filter(row => 
      row.task && row.task.trim() !== ""
    );
    
    // Check if all rows with task have hours filled
    return rowsWithTask.every(row => 
      row.hoursassigned !== undefined && 
      row.hoursassigned !== null && 
      row.hoursassigned.toString().trim() !== ""
    );
  };

  const handleAction = async () => {
    SetisLoading(true);
    try {
      const serviceType = row.TypeService.toLowerCase();

      switch (true) {
        case serviceType.includes('installation'):
          await handledirectSubmit();
          await handleinstallationtaskSubmit(tripduration);
          await updatebyname()
          break;

        case serviceType.includes('hardware'):
          await handlehardwaretaskSubmit(hardware);
          await handleDescriptionSubmitofManager();
          await updatebyname()
          break;

        case serviceType.includes('software'):
        case serviceType.includes('cloud'):
          await handledirectSubmit();
          await handleDescriptionSubmitofManager();
          await updatebyname()
          break;

        default:
          await handledirectSubmit();
          await handleDescriptionSubmitofManager();
          await handlehardwaretaskSubmit(hardware);
          await handleinstallationtaskSubmit(tripduration);
          await updatebyname()
      }

      if (serviceType.includes('installation') && !tripduration) {
        return
      }
      enqueueSnackbar("Response Submitted Successfully.", {
        variant: "success",
      });
      handlerefresh()
    } catch (error) {
      enqueueSnackbar("Error occurred: " + error.message, {
        variant: "error",
      });
    } finally {
      SetisLoading(false);
    }
  };
  return (
    <>
      {isLoading ? <AdminLoader isLoading={isLoading} /> : <></>}
      <div className={`custom-scroll w-full  h-full justify-center ${taskTableRowId === row?._id ? "min-h-[20vh]" : ""} max-h-[53vh] overflow-auto pb-5`} ref={maintaskdivRef}>
        {((Array.isArray(row.TypeService)
          ? row.TypeService.some((service) =>
            ["Installation"].some((keyword) => service.includes(keyword))
          )
          : ["Installation"].some((keyword) =>
            row.TypeService?.includes(keyword)
          )) && Action === "otherExpenses") && (
            <div
              className=" maintaskdiv w-full bg-white"
            >
              <div className="w-full bg-white rounded-lg h-full justify-center pb-5">
                <div className="flex flex-col w-full">
                  <div className="w-full">
                    <div className="head flex text-center bg-[#1973eb] text-white text-xs">
                      <div className="w-[50%] border p-2 font-semibold">
                        Trip Duration (Days)
                      </div>
                      <div className="w-[50%] border p-2">
                        {Assignperson?.taskStatus === "submit"
                          ? (
                            <>
                              {tripduration}
                            </>
                          ) : (
                            <input
                              value={tripduration}
                              type="text"
                              onChange={(e) => {
                                handletripdurationChange(e.target.value); // Pass the value directly
                              }}
                              placeholder="Enter duration"
                              className="h-full w-full outline-none bg-[#1973eb]"
                            />
                          )}

                      </div>
                    </div>
                  </div>

                  <div className="w-full">
                    <div className="head flex text-center bg-[#1973eb] text-white text-xs">
                      <div className="w-[10%] border p-1 flex justify-center align-middle items-center">Sr. No</div>
                      <div className="w-[40%] border p-2">Description</div>
                      <div className="w-[25%] border p-2">Amount ({currency})</div>
                      <div className="w-[25%] border p-2">Notes</div>
                    </div>
                    <div className="head flex text-center text-xs">
                      <div className="w-[10%] border p-1 flex justify-center align-middle items-center"></div>
                      <div className="w-[40%] border p-2">Total</div>
                      <div className="w-[25%] border p-2">
                        {formatAmountComma(totalDollerValue + (shouldShowLockedTrainingRows ? lockedTrainingCostTotal : 0))}
                      </div>
                      <div className="w-[25%] border p-2"></div>
                    </div>
                  </div>
                </div>
                <div className="w-full">
                  {installationForTableDisplay.map((row, index) => (
                    <React.Fragment key={index}>
                      {Assignperson?.taskStatus === "submit"
                        ? (
                          <div className="flex items-center text-center w-full text-xs">
                            <div className="w-full">
                              <div className="head flex">
                                <div className="w-[10%] border p-1">{index + 1}</div>

                                <div className="w-[40%] border p-2">
                                  {row.description}
                                </div>
                                <div className="w-[25%] border p-2">
                                  {formatAmountComma(row.value)}
                                </div>
                                <div className="w-[25%] border p-2">
                                  {row.notes}
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="flex items-center text-center w-full text-xs">
                            <div className="w-full">
                              <div className="head flex">
                                <div className="w-[10%] border p-1">{index + 1}</div>

                                <div className="w-[40%] border p-2">
                                  {/* {row.description} */}
                                  <input
                                    type="text"
                                    name="description"
                                    value={row.description}
                                    placeholder="Enter Value"
                                    onKeyDown={(e) => {
                                      if (["+", "-"].includes(e.key)) {
                                        e.preventDefault();
                                      }
                                    }}
                                    onChange={(e) => {
                                      const Value = e.target.value
                                      handleInstallationChange(
                                        index,
                                        "description",
                                        Value
                                      );
                                    }}
                                    className="outline-none border-none text-center w-full h-full"
                                  />
                                </div>

                                <div className="w-[25%] border p-2">
                                  <input
                                    type="text"
                                    name="value"
                                    value={formatAmountForInput(row.value)}
                                    placeholder="Enter Value"
                                    onFocus={(e) => {
                                      if (e.target.value === "0") e.target.select();
                                    }}
                                    onClick={(e) => {
                                      if (e.target.value === "0") e.target.select();
                                    }}
                                    onKeyDown={(e) => {
                                      if (["e", "E", "+", "-"].includes(e.key)) {
                                        e.preventDefault();
                                      }
                                    }}
                                    onChange={(e) => {
                                      handleInstallationChange(
                                        index,
                                        "value",
                                        validateAmountValue(e.target.value)
                                      );
                                    }}
                                    className="outline-none border-none text-center w-full h-full"
                                  />
                                </div>

                                <div className="w-[25%] border p-2">
                                  <input
                                    type="text"
                                    name="notes"
                                    value={row.notes}
                                    placeholder="Enter Notes"
                                    onChange={(e) => {

                                      const validValue = e.target.value.replace(
                                        /[^a-zA-Z0-9 ]/g,  // Note the added space in the character class
                                        ""
                                      );
                                      handleInstallationChange(
                                        index,
                                        "notes",
                                        validValue
                                      );
                                    }}
                                    className="outline-none border-none text-center w-full h-full"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                    </React.Fragment>
                  ))}

                  {shouldShowLockedTrainingRows && lockedTrainingRow && (
                    <div className="flex items-center text-center w-full text-xs">
                      <div className="w-full">
                        <div className="head flex">
                          <div className="w-[10%] border p-1">{installation.length + 1}</div>
                          <div className="w-[40%] border p-2">
                            <input
                              type="text"
                              value={lockedTrainingRow.description}
                              disabled
                              className="outline-none border-none text-center w-full h-full bg-[#e5e7eb] text-[#6b7280] cursor-not-allowed"
                            />
                          </div>
                          <div className="w-[25%] border p-2">
                            <input
                              type="text"
                              value={formatAmountComma(lockedTrainingRow.amount)}
                              disabled
                              className="outline-none border-none text-center w-full h-full bg-[#e5e7eb] text-[#6b7280] cursor-not-allowed"
                            />
                          </div>
                          <div className="w-[25%] border p-2">
                            <input
                              type="text"
                              value={lockedTrainingRow.notes}
                              disabled
                              className="outline-none border-none text-center w-full h-full bg-[#e5e7eb] text-[#6b7280] cursor-not-allowed"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {Assignperson?.taskStatus === "submit" ? null : (
                    <div className="flex justify-between px-2 pt-1">
                      <button
                        type="button"
                        className="shadow-xl rounded-md p-1"
                        onClick={handleAddinstallationrow}
                        disabled={triprows.length >= 15}
                      >
                        <AddIcon />
                      </button>
                      <button
                        type="button"
                        className="shadow-xl rounded-md p-1"
                        onClick={handleRemoveinstallationrow}
                      >
                        <RemoveIcon />
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

        {Action === "task" && (
          <div className="">
            <div className="flex w-full">
              <div className="w-full">
                <div className="head flex text-center bg-[#1973eb] text-white text-xs">
                  <div className="w-[10%] border p-1 flex justify-center align-middle items-center">Sr. No</div>
                  <div className="w-[40%] border p-2">Task</div>
                  <div className="w-[20%] border p-2">Hours</div>
                  <div className="w-[30%] border p-2">Notes</div>
                </div>
              </div>
            </div>

            {/* Total Row */}
            <div className="flex text-center w-full text-xs">
              <div className="w-full">
                <div className="head flex">
                  <div className="w-[10%] border p-1"></div>
                  <div className="w-[40%] border p-2">Total</div>
                  <div className="w-[20%] border p-2">
                    {totalHoursAssigned}
                  </div>
                  <div className="w-[30%] border p-2"></div>
                </div>
              </div>
            </div>

            {/* Task Rows */}
            <div className="w-full">
              {rows.map((row, index) => (
                <React.Fragment key={index}>

                  {Assignperson?.taskStatus === "submit"
                    ? (
                      <div className="flex items-center text-center w-full text-xs">
                        <div className="w-full">
                          <div className="head flex">
                            <div className="w-[10%] border p-1">{index + 1}</div>

                            <div className="w-[40%] border p-2">
                              {row.task || ""}
                            </div>
                            <div className="w-[20%] border p-2">
                              {row.hoursassigned || ""}
                            </div>

                            <div className="w-[30%] border p-2">
                              {row.notes || ""}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="flex items-center text-center w-full text-xs">
                        <div className="w-full">
                          <div className="head flex">
                            <div className="w-[10%] border p-1">{index + 1}</div>

                            <div className="w-[40%] border p-2">
                              <input
                                type="text"
                                name="task"
                                value={row.task || ""}
                                onChange={(e) => {
                                  const validValue = e.target.value.replace(
                                    /[^a-zA-Z0-9 ]/g,  // Note the added space in the character class
                                    ""
                                  );
                                  handleInputChange(index, "task", validValue);
                                }}
                                className="outline-none border-none text-center w-full h-full"
                              />
                            </div>
                            <div className="w-[20%] border p-2">
                              <input
                                type="text"
                                name="hoursassigned"
                                value={row.hoursassigned || ""}
                                onKeyDown={(e) => {
                                  if (["e", "E", "+", "-"].includes(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={(e) => {
                                  const value = sanitizeDecimalInput(e.target.value);

                                  handleInputChange(
                                    index,
                                    "hoursassigned",
                                    value
                                  );
                                }}
                                className="outline-none border-none text-center w-full h-full"
                              />
                            </div>

                            <div className="w-[30%] border p-2">
                              <input
                                type="text"
                                name="notes"
                                value={row.notes || ""}
                                onChange={(e) => {
                                  const validValue = e.target.value.replace(
                                    /[^a-zA-Z0-9 ]/g,  // Note the added space in the character class
                                    ""
                                  );

                                  handleInputChange(index, "notes", validValue);
                                }}
                                className="outline-none border-none text-center w-full h-full"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}


                  {/* Add/Remove Buttons - Only show for last row */}
                  {index === rows.length - 1 && (
                    Assignperson?.taskStatus === "submit"
                      ? (
                        <></>
                      ) : (
                        <div className="flex justify-between px-2 pt-1 pb-2">
                          <button
                            type="button"
                            className="shadow-xl rounded-md p-1 bg-gray-100 hover:bg-gray-200"
                            onClick={handleAddTaskRow}
                            title="Add row"
                          >
                            <AddIcon fontSize="small" />
                          </button>
                          <button
                            type="button"
                            className="shadow-xl rounded-md p-1 bg-gray-100 hover:bg-gray-200"
                            onClick={() => handleRemoveTaskRow(index)}
                            // disabled={rows.length === 1}
                            title="Remove row"
                          >
                            <RemoveIcon fontSize="small" />
                          </button>
                        </div>
                      )

                  )}
                </React.Fragment >
              ))}
            </div >
          </div >
        )}

        {
          hardwareAction === "hardwarecost" && (
            <div className="mainhardwarekdiv w-full bg-white">
              <div className="w-full bg-white rounded-lg h-full justify-center pb-5">
                {/* Table Header */}
                <div className="flex flex-col w-full">
                  <div className="w-full flex flex-col">
                    <div className="head flex text-center bg-[#1973eb] text-white text-xs">
                      <div className="w-[10%] border p-1 flex justify-center align-middle items-center">Sr. No</div>
                      <div className="w-60 border py-1 break-words">
                        Assembly/Part Description
                      </div>
                      <div className="w-[20%] border p-1">Part No</div>
                      <div className="w-[20%] border p-1">Quantity</div>
                      <div className="w-[20%] border p-1">Unit Cost ({currency})</div>
                      <div className="w-[20%] border p-1">Total Cost ({currency})</div>
                    </div>
                    <div className="head flex text-center bg-blue-500  text-white text-[11px]">
                      <div className=" border w-[10%] p-1 break-all whitespace-normal"></div>
                      <div className=" border w-60 pt-1  break-all whitespace-normal">
                        Total
                      </div>
                      <div className=" border w-[20%]  break-all whitespace-normal  p-1">
                        {" "}
                      </div>
                      <div className=" border w-[20%] break-all whitespace-normal p-1"></div>
                      <div className=" border w-[20%] break-all whitespace-normal p-1">
                        {" "}
                      </div>
                      <div className=" border w-[20%] break-all whitespace-normal p-1">
                        {USAComma(
                          hardware?.reduce((sum, item) => {
                            return sum + Number(item.totalprice);
                          }, 0)
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="w-full">
                  {hardware?.map((row, index) => (
                    <React.Fragment key={index}>

                      {Assignperson?.taskStatus === "submit"
                        ? (
                          <div className="flex items-center text-center w-full text-xs">
                            <div className="w-full">
                              <div className="head flex">
                                <div className="w-[10%] border p-1">{index + 1}</div>
                                {/* Description Select */}
                                <div className="w-60 border p-1 break-all whitespace-normal">
                                  {row.assemblepartdescription || ""}
                                </div>

                                {/* Part Number */}
                                <div className="w-[20%] border p-1 break-all whitespace-normal">
                                  {row.partno || ""}
                                </div>

                                {/* Quantity Input */}
                                <div className="w-[20%] border p-1 break-all whitespace-normal">
                                  {row.quantity || ""}
                                </div>

                                {/* Unit Price */}
                                <div className="w-[20%] border p-1 break-all whitespace-normal">
                                  {USAComma(row.unitprice) || ""}
                                </div>

                                {/* Total Price */}
                                <div className="w-[20%] border p-1 break-all whitespace-normal">
                                  {USAComma(row.totalprice || "")}
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="flex items-center text-center w-full text-xs">
                            <div className="w-full">
                              <div className="head flex">
                                <div className="w-[10%] border p-1">{index + 1}</div>

                                {/* Description Select */}
                                <div className="w-60 border p-1 break-all whitespace-normal">
                                  <select
                                    name="assemblepartdescription"
                                    value={row.assemblepartdescription || ""}
                                    onChange={(e) =>
                                      handlehardwareInputChange(
                                        index,
                                        "assemblepartdescription",
                                        e.target.value
                                      )
                                    }
                                    onFocus={handleSelectOpen}
                                    className="outline-none text-black border-none bg-white text-center w-full h-full"
                                  >
                                    <option hidden value="">Select</option>
                                    {fetchedHardwareData?.map((option) => {
                                      const isAlreadySelected = hardware.some(
                                        (row, i) =>
                                          row.assemblepartdescription ===
                                          option.assemblepartdescription && i !== index
                                      );

                                      return (
                                        <option
                                          key={option._id}
                                          value={option.assemblepartdescription}
                                          disabled={isAlreadySelected}
                                        >
                                          {option.assemblepartdescription}
                                        </option>
                                      );
                                    })}
                                  </select>
                                </div>

                                {/* Part Number */}
                                <div className="w-[20%] border p-1 break-all whitespace-normal">
                                  {row.partno || "--"}
                                </div>

                                {/* Quantity Input */}
                                <div className="w-[20%] border p-1 break-all whitespace-normal">
                                  <input
                                    type="number"
                                    placeholder="enter quantity "
                                    value={row.quantity || ""}
                                    onChange={(e) => {
                                      let value = e.target.value;
                                      if (/^\d*\.?\d{0,3}$/.test(value) || value === "") {
                                        handlehardwareInputChange(index, "quantity", value);
                                      }
                                    }}
                                    onKeyDown={(e) => {
                                      // Block minus and other unwanted keys
                                      if (
                                        !(
                                          (e.key >= "0" && e.key <= "9") || // numbers
                                          e.key === "." || // decimal
                                          e.key === "Backspace" ||
                                          e.key === "Delete" ||
                                          e.key === "ArrowLeft" ||
                                          e.key === "ArrowRight" ||
                                          e.key === "Tab"
                                        )
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                    className="w-full h-full border text-center border-gray-300 rounded-md p-0.5"
                                  />
                                </div>

                                <div className="w-[20%] border p-1 break-all whitespace-normal">
                                  {USAComma(row.unitprice) || ""}
                                </div>

                                <div className="w-[20%] border p-1 truncate break-all whitespace-normal">
                                  {USAComma(row.totalprice || "")}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                    </React.Fragment>
                  ))}

                  {Assignperson?.taskStatus === "submit"
                    ? (
                      <></>
                    ) : (
                      <div className="flex justify-between px-2 pt-1">
                        <button
                          className="shadow-xl rounded-md p-1"
                          onClick={handleAddHardware}
                          disabled={hardware.length >= 15}
                        >
                          <AddIcon />
                        </button>
                        <button
                          className="shadow-xl rounded-md p-1"
                          onClick={handleRemoveHardware}
                        >
                          <RemoveIcon />
                        </button>
                      </div>)}
                </div>
              </div>
            </div>

          )
        }
        {
          ((hardwareAction === "otherexpenses") || ((Array.isArray(row.TypeService)
            ? row.TypeService.some((service) =>
              ["Software", "Cloud"].some((keyword) => service.includes(keyword))
            )
            : ["Software", "Cloud"].some((keyword) =>
              row.TypeService?.includes(keyword)
            )) && Action === "otherExpenses")) && (
            <div className="maintaskdiv w-full bg-white">
              <div className="w-full bg-white rounded-lg h-full justify-center pb-5">
                <div className="flex flex-col w-full">
                  <div className="w-full">
                    <div className="head flex text-center bg-[#1973eb] text-white text-xs">
                      <div className="w-[10%] border p-1 flex justify-center align-middle items-center">Sr. No</div>
                      <div className="w-[40%] border p-2">Description</div>
                      <div className="w-[25%] border p-2">Amount ({currency})</div>
                      <div className="w-[25%] border p-2">Notes</div>
                    </div>
                  </div>
                  <div className="w-full">
                    <div className="head flex text-center  text-xs">
                      <div className="w-[10%] border p-1 flex justify-center align-middle items-center"></div>
                      <div className="w-[40%] border p-2">Total</div>
                      <div className="w-[25%] border p-2">
                        {formatAmountComma(totalDollerValue + (shouldShowLockedTrainingRows ? lockedTrainingCostTotal : 0))}
                      </div>
                      <div className="w-[25%] border p-2"></div>
                    </div>
                  </div>
                </div>
                <div className="w-full">
                  {triprows.map((row, index) => (
                    <React.Fragment key={index}>
                      {Assignperson?.taskStatus === "submit"
                        ? (
                          <div className="flex items-center text-center w-full text-xs">
                            <div className="w-full">
                              <div className="head flex">
                                <div className="w-[10%] border p-1">
                                  {index + 1}
                                </div>

                                <div className="w-[40%] border p-2">
                                  {row.description}
                                </div>

                                <div className="w-[25%] border p-2">
                                  {formatAmountComma(row.value)}
                                </div>

                                <div className="w-[25%] border p-2">
                                  {row.notes}
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="flex items-center text-center w-full text-xs">
                            <div className="w-full">
                              <div className="head flex">
                                <div className="w-[10%] border p-1">
                                  {index + 1}
                                </div>

                                <div className="w-[40%] border p-2">
                                  <input
                                    type="text"
                                    name="description"
                                    value={row.description}
                                    onChange={(e) =>
                                      handleTripInputChange(
                                        index,
                                        "description",
                                        validateDescriptionOrNotes(e.target.value)
                                      )
                                    }
                                    placeholder="Enter Description"
                                    className="outline-none border-none text-center w-full h-full"
                                  />
                                </div>

                                <div className="w-[25%] border p-2">
                                  <input
                                    type="text"
                                    name="value"
                                    value={formatAmountForInput(row.value)}
                                    onFocus={(e) => {
                                      if (e.target.value === "0") e.target.select();
                                    }}
                                    onClick={(e) => {
                                      if (e.target.value === "0") e.target.select();
                                    }}
                                    onChange={(e) =>
                                      handleTripInputChange(
                                        index,
                                        "value",
                                        validateAmountValue(e.target.value)
                                      )
                                    }
                                    onKeyDown={(e) => {
                                      if (["e", "E", "+", "-"].includes(e.key)) {
                                        e.preventDefault();
                                      }
                                    }}
                                    className="outline-none border-none text-center w-full h-full"
                                  />
                                </div>

                                <div className="w-[25%] border p-2">
                                  <input
                                    type="text"
                                    name="notes"
                                    value={row.notes}
                                    placeholder="Enter Notes"
                                    onChange={(e) =>
                                      handleTripInputChange(
                                        index,
                                        "notes",
                                        validateDescriptionOrNotes(e.target.value)
                                      )
                                    }
                                    className="outline-none border-none text-center w-full h-full"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                    </React.Fragment>
                  ))}

                  {shouldShowLockedTrainingRows && lockedTrainingRow && (
                    <div className="flex items-center text-center w-full text-xs">
                      <div className="w-full">
                        <div className="head flex">
                          <div className="w-[10%] border p-1">{triprows.length + 1}</div>
                          <div className="w-[40%] border p-2">
                            <input
                              type="text"
                              value={lockedTrainingRow.description}
                              disabled
                              className="outline-none border-none text-center w-full h-full bg-[#e5e7eb] text-[#6b7280] cursor-not-allowed"
                            />
                          </div>
                          <div className="w-[25%] border p-2">
                            <input
                              type="text"
                              value={formatAmountComma(lockedTrainingRow.amount)}
                              disabled
                              className="outline-none border-none text-center w-full h-full bg-[#e5e7eb] text-[#6b7280] cursor-not-allowed"
                            />
                          </div>
                          <div className="w-[25%] border p-2">
                            <input
                              type="text"
                              value={lockedTrainingRow.notes}
                              disabled
                              className="outline-none border-none text-center w-full h-full bg-[#e5e7eb] text-[#6b7280] cursor-not-allowed"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {Assignperson?.taskStatus === "submit" ? null : (
                    <div className="flex justify-between px-2 pt-1">
                      <button
                        type="button"
                        className="shadow-xl rounded-md p-1"
                        onClick={handleAddRow}
                        disabled={triprows.length >= 15}
                      >
                        <AddIcon />
                      </button>
                      <button
                        type="button"
                        className="shadow-xl rounded-md p-1"
                        onClick={handleRemoveRow}
                      >
                        <RemoveIcon />
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )
        }

        {Assignperson?.taskStatus === "submit" ? (
          <></>
        ) : (
          <div className="flex gap-2 w-auto justify-end py-1">
            {isLoadingtask && (
              <div className="mt-4 flex gap-1 align-middle items-center">
                <div className="text-sm">Saving Tasks </div>
                <SubmitLoader isLoadingtask={isLoadingtask} />
              </div>
            )}
            {canShowSubmit && (
              <button
                disabled={row.taskStatus === "autosave"}
                onClick={() => {
                  if (!areAllTaskHoursFilled()) {
                    enqueueSnackbar("Please fill all the field.", {
                      variant: "error",
                    });
                    return;
                  }
                  handleAction();
                }}
                className={`mt-4 px-4 py-2 rounded-md ${
                  row.taskStatus === "autosave" || !areAllTaskHoursFilled()
                    ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                    : "bg-blue-600 text-white hover:bg-blue-700"
                }`}
              >
                Submit
              </button>
            )}
          </div>
        )}
      </div >
    </>
  );
};

export default TaskInputTable;
